import axios, { AxiosError } from 'axios';
import history from 'utils/history';

const apiSinosserraDigital = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_SS_DIGITAL,
});

apiSinosserraDigital.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (error.response?.data?.error === 'Unauthorized') {
        localStorage.removeItem('token');
        apiSinosserraDigital.defaults.headers.Authorization = undefined;
        history.push('/');
      }
    }
    return Promise.reject(error);
  }
);
export default apiSinosserraDigital;
